import React, { FC } from "react";
import { Container, Menu } from "semantic-ui-react";

const Header: FC<{}> = () => (
  <>
    <Menu fixed="top" inverted size="massive">
      <Container>
        <a href="/">
          <Menu.Item as="a" header link>
            幸せ度チェッカー
          </Menu.Item>
        </a>
      </Container>
    </Menu>
  </>
);

export default Header;
